import { SideNavigationMenuItemType } from "../types/SideNavigationTypes";
import classNames from "classnames";
import styles from "./SideNavigationMenuItem.module.scss";
import { useIsTertiaryChild } from "../side-navigation-contexts/SideNavigationTertiaryMenuItemContext";
import { SideNavigationMenuItemDropdown } from "./SideNavigationMenuItemElements/SideNavigationMenuItemDropdown";
import { SideNavigationMenuItemElementProps } from "./SideNavigationMenuItemElements/SideNavigationMenuItemElementTypes";
import { SideNavigationMenuItemAccordion } from "./SideNavigationMenuItemElements/SideNavigationMenuItemAccordion";
import { useSideNavigationCollapseContext } from "../side-navigation-contexts";

export const SideNavigationMenuItem = (props: SideNavigationMenuItemType) => {
  const { isCollapsed } = useSideNavigationCollapseContext();
  const isTertiaryChild = useIsTertiaryChild();

  const baseLevelMenuItemStyling = classNames(
    styles.sideNavigationBaseLevelMenuItem,
    { [styles.collapsed]: isCollapsed },
  );

  const menuItemElementProps: SideNavigationMenuItemElementProps = {
    ...props,
    isTertiaryChild: isTertiaryChild,
    baseContainerStyling: baseLevelMenuItemStyling,
    isSubMenuItem: false,
  };

  let typeOfElementToDisplay;

  // level === 0 -> base element
  // level > 0 -> dropdown element
  // isTertiaryChild -> dropdown element
  if (isCollapsed) {
    typeOfElementToDisplay = (
      <SideNavigationMenuItemDropdown {...menuItemElementProps} />
    );
  } else if (
    (props.level === 0 && (!props.children || props.children.length < 1)) ||
    isTertiaryChild
  ) {
    typeOfElementToDisplay = (
      <SideNavigationMenuItemDropdown {...menuItemElementProps} />
    );
  } else if (props.level === 0 && props.children && props.children.length > 0) {
    typeOfElementToDisplay = (
      <SideNavigationMenuItemAccordion {...menuItemElementProps} />
    );
  } else {
    typeOfElementToDisplay = (
      <SideNavigationMenuItemDropdown {...menuItemElementProps} />
    );
  }

  return typeOfElementToDisplay;
};
